(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/service-fraction/assets/services/post-fraction.js') >= 0) return;  svs.modules.push('/components/payment/service-fraction/assets/services/post-fraction.js');

'use strict';

const {
  RequestFractionPaymentError
} = svs.components.payment.common.error;
const {
  jupiterFetch
} = svs.core;


const postFraction = async _ref => {
  let {
    activatedDrawId,
    count = 1
  } = _ref;
  try {
    const response = await jupiterFetch.fetch("/marketplace/1/activateddraws/".concat(activatedDrawId, "/soldshares"), {
      method: 'POST',
      body: JSON.stringify({
        numShares: count
      }),
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json'
      }
    });
    const data = await response.json();
    if (!response.ok) {
      var _data$error, _data$error2;
      throw new RequestFractionPaymentError({
        clientCode: RequestFractionPaymentError.ClientErrorCodes.PAYMENT_REQUEST_FAILURE,
        code: (_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.code,
        extraData: {
          message: (_data$error2 = data.error) === null || _data$error2 === void 0 ? void 0 : _data$error2.message
        }
      });
    }
    return data;
  } catch (error) {
    switch (error === null || error === void 0 ? void 0 : error.name) {
      case 'TypeError':
        throw new RequestFractionPaymentError({
          clientCode: RequestFractionPaymentError.ClientErrorCodes.PAYMENT_FETCH_FAILURE,
          code: error === null || error === void 0 ? void 0 : error.code,
          extraData: {
            message: error === null || error === void 0 ? void 0 : error.message
          }
        });
      default:
        throw error;
    }
  }
};
setGlobal('svs.components.payment.serviceFraction.services.postFraction', postFraction);

 })(window);